import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type { ConfigDto, PlanDto, PlanImportPreviewDto } from "@audit-plan/shared";
import { api } from "./client";

export const usePlan = (year: number) => useQuery({ queryKey: ["plan", year], queryFn: () => api.get<PlanDto>("/plan", { year }) });

export const useConfig = () => useQuery({ queryKey: ["config"], queryFn: () => api.get<ConfigDto>("/config"), staleTime: 60_000 });
/** Classe di rischio e copertura visite visibili (interruttore in Configurazione; visibili finché la configurazione non è caricata). */
export const useShowRisk = () => useConfig().data?.showRisk !== false;

export function usePlanImportPreview() {
  return useMutation({
    mutationFn: (file: File) => {
      const fd = new FormData();
      fd.append("file", file);
      return api.post<PlanImportPreviewDto>("/plan/import/preview", fd);
    },
  });
}

export function usePlanImportConfirm() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (rows: { supplierId: string; factoryId?: string | null; type: string; date: string; dateTo?: string | null; auditorId: string }[]) =>
      api.post<{ created?: number; count?: number } | unknown[]>("/plan/import/confirm", { rows }),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["plan"] });
      void qc.invalidateQueries({ queryKey: ["audits"] });
      void qc.invalidateQueries({ queryKey: ["dashboard"] });
    },
  });
}
